import { Injectable } from '@angular/core';
import { BehaviorSubject, asapScheduler } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private _show = new BehaviorSubject<boolean>(false);
  private _text = new BehaviorSubject<string>('Cargando...');

  readonly show$ = this._show.asObservable();
  readonly text$ = this._text.asObservable();

  show(text = 'Cargando...') {
    asapScheduler.schedule(() => {
      this._text.next(text);
      this._show.next(true);
    });
  }

  hide() {
    asapScheduler.schedule(() => {
      this._show.next(false);
      this._text.next('Cargando...');
    });
  }
}
